import { useState } from "react";
import { useEffectOnce } from "@made-people/react-use-effect-once";
import { BffClient } from "@made-people/gears-bff-client";
import { z } from "zod";

const allocationRuleSchema = z.object({
  id: z.number(),
  name: z.string(),
  warehouses: z.array(
    z.object({
      id: z.number(),
      name: z.string(),
    }),
  ),
});

type AllocationRule = z.infer<typeof allocationRuleSchema>;

export function useAllocationRuleFetch(bffClient: BffClient, market: string) {
  const [allocationRule, setAllocationRule] = useState<AllocationRule | null>(
    null,
  );
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  useEffectOnce(() => {
    bffClient
      .fetchAllocationRule(market)
      .then((result) => {
        if (!result) {
          setAllocationRule(null);
          setIsLoading(false);
          return;
        }
        const parsed = allocationRuleSchema.safeParse(result);
        if (!parsed.success) {
          console.error(
            "Allocation rule response failed validation",
            parsed.error,
          );
          setHasError(true);
          setAllocationRule(null);
        } else {
          setAllocationRule(parsed.data);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error(
          "Failed to fetch allocation rule — check BFF logs for details",
          error,
        );
        setHasError(true);
        setAllocationRule(null);
        setIsLoading(false);
      });
  });

  return { allocationRule, isLoading, hasError };
}
